import React from "react";
import { Link } from "react-router-dom";
import ContentPage, { Block, CardGrid } from "../components/ContentPage";

const PACKAGES = [
  {
    title: "Familie Boodschappenpakket",
    body: "Een praktisch pakket met populaire dagelijkse boodschappen voor een huishouden.",
    price: "Bekijk prijs in de app",
  },
  {
    title: "Mama & Papa Pakket",
    body: "Een zorgvuldig samengesteld pakket met boodschappen en verzorgingsproducten voor ouders en ouderen.",
    price: "Bekijk prijs in de app",
  },
  {
    title: "Baby- en Gezinspakket",
    body: "Een pakket met praktische producten voor baby's, jonge kinderen en gezinnen.",
    price: "Bekijk prijs in de app",
  },
  {
    title: "Verjaardagspakket",
    body: "Een feestelijk pakket met lekkernijen, drankjes en een persoonlijke boodschap.",
    price: "Bekijk prijs in de app",
  },
  {
    title: "Huishoudpakket",
    body: "Een selectie schoonmaakproducten, wasmiddelen en andere benodigdheden voor thuis.",
    price: "Bekijk prijs in de app",
  },
  {
    title: "Maandpakket",
    body: "Een compleet pakket voor mensen die hun familie regelmatig willen ondersteunen.",
    price: "Bekijk prijs in de app",
  },
];

export default function PakkettenPage() {
  return (
    <ContentPage
      title="Samengestelde familiepakketten"
      lead="Weet je niet precies welke producten je moet kiezen? Kies dan een van onze samengestelde pakketten."
      ctaLabel="Bekijk alle familiepakketten"
      secondaryLabel="Ontdek het Familieplan"
      secondaryTo="/familieplan"
    >
      <CardGrid items={PACKAGES} />
      <Block title="Voor elk bijzonder moment">
        <p>
          Suriwebwinkel helpt je om belangrijke momenten samen te vieren, ook
          wanneer je niet zelf in Suriname aanwezig kunt zijn. Bekijk ook onze{" "}
          <Link to="/momenten">speciale momenten</Link>.
        </p>
      </Block>
    </ContentPage>
  );
}
